export const LOCATIONS = [
  {
    slug: "kitchener", name: "Kitchener", region: "Kitchener-Waterloo",
    housing: "Character homes, post-war bungalows & new subdivisions",
    intro: "Kitchener's mix of century homes near Victoria Park, post-war bungalows and growing new subdivisions keeps our crew busy year-round. We handle careful updates in older homes and full main-floor transformations in newer ones.",
    popular: ["Century-home kitchen remodels", "Basement apartments & suites", "Full main-floor renovations"],
  },
  {
    slug: "waterloo", name: "Waterloo", region: "Kitchener-Waterloo",
    housing: "University-area properties & established family homes",
    intro: "In Waterloo we renovate everything from properties near the universities to family homes in Laurelwood and Beechwood. Rental-ready basement suites and durable, low-maintenance finishes are our most common requests.",
    popular: ["Rental-ready basement suites", "Bathroom modernizations", "Durable flooring for busy homes"],
  },
  {
    slug: "cambridge", name: "Cambridge", region: "Kitchener-Waterloo",
    housing: "Heritage stone homes & newer builds",
    intro: "Cambridge's heritage stone homes in Galt and newer builds in Hespeler and Preston each need a different touch. We're experienced with heritage-sensitive updates as well as modern open-concept conversions.",
    popular: ["Heritage-home updates in Galt", "Open-concept main floors", "Custom trim & millwork"],
  },
  {
    slug: "guelph", name: "Guelph", region: "Wellington County",
    housing: "Limestone character homes & family neighbourhoods",
    intro: "Guelph's limestone character homes call for renovations that respect the original build. From bathroom remodels to finished basements, we bring modern comfort without losing the charm.",
    popular: ["Bathroom remodels in character homes", "Basement finishing", "Interior painting & trim"],
  },
  {
    slug: "toronto", name: "Toronto", region: "GTA",
    housing: "Victorian semis, row houses & post-war bungalows",
    intro: "Toronto homes demand smart use of every square foot. We specialize in kitchens, full-home renovations and interior work that makes compact city homes live large — with minimal disruption to your neighbours.",
    popular: ["Victorian semi renovations", "Compact kitchen redesigns", "Full-home transformations"],
  },
  {
    slug: "mississauga", name: "Mississauga", region: "GTA",
    housing: "Detached homes & townhouses from the 70s–90s",
    intro: "Mississauga's detached homes and townhouses from the 70s, 80s and 90s are perfect candidates for modern kitchens, new flooring and finished basements. We help homeowners from Streetsville to Port Credit update with confidence.",
    popular: ["Kitchen renovations", "Whole-home flooring", "Basement finishing"],
  },
  {
    slug: "brampton", name: "Brampton", region: "GTA",
    housing: "Growing family homes & multi-generational living",
    intro: "Brampton's growing families often need more space without moving. Basement suites for extended family, bigger kitchens and complete main-floor refreshes are the projects we deliver most across Brampton.",
    popular: ["Basement suites for extended family", "Family-sized kitchen remodels", "Main-floor transformations"],
  },
  {
    slug: "vaughan", name: "Vaughan", region: "GTA",
    housing: "Newer two-storeys ready for custom finishes",
    intro: "Many Vaughan homes are newer builds ready to move beyond builder-grade finishes. We upgrade kitchens, bathrooms and millwork to a custom standard that matches the value of the home.",
    popular: ["Builder-grade kitchen upgrades", "Custom trim packages", "Ensuite renovations"],
  },
  {
    slug: "markham", name: "Markham", region: "GTA",
    housing: "Unionville character streets & newer family communities",
    intro: "From Unionville's character streets to newer Cornell family homes, Markham renovations range from careful updates to complete redesigns. Bathrooms, interiors and kitchens are our most-booked projects here.",
    popular: ["Bathroom renovations", "Interior updates & painting", "Kitchen remodels"],
  },
  {
    slug: "richmond-hill", name: "Richmond Hill", region: "GTA",
    housing: "Larger detached homes & luxury finishes",
    intro: "Richmond Hill's larger detached homes suit bigger transformations — premium kitchens, spa-style bathrooms and full-home renovations with high-end finishes throughout.",
    popular: ["Premium kitchen renovations", "Spa-style bathrooms", "Complete home renovations"],
  },
  {
    slug: "oakville", name: "Oakville", region: "GTA",
    housing: "Upscale established neighbourhoods",
    intro: "Oakville homeowners expect a premium finish, and that's our standard. We deliver high-end kitchens, bathrooms and whole-home projects across Oakville's established neighbourhoods.",
    popular: ["High-end kitchen & bath projects", "Whole-home renovations", "Fine finish carpentry"],
  },
  {
    slug: "burlington", name: "Burlington", region: "GTA",
    housing: "Established family homes near the lake & escarpment",
    intro: "Burlington's established family homes are ideal for basement finishing, flooring and kitchen updates. We help homeowners modernize while keeping projects on schedule and on budget.",
    popular: ["Basement finishing", "Flooring installation", "Kitchen updates"],
  },
];
